import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Col, Form, Input, Row, Space } from 'antd';
import { useEffect, useRef } from 'react';

import { hrefValidate } from '@/utils/ruleValidate';

const RedirectUrls = ({
  initialValue,
  title,
  required,
  placeholder,
  disabled = false,
  onChange: _onChange,
}: {
  initialValue: string;
  title: any;
  placeholder: string;
  disabled?: boolean;
  onChange: (val: string) => void;
  required?: boolean;
}) => {
  const [form] = Form.useForm();
  const initValueBool = useRef(false);
  useEffect(() => {
    if (!initValueBool.current) {
      form.setFieldValue('urls', (initialValue || '').split(','));
    }
    if (initialValue) {
      initValueBool.current = true;
    }
  }, [initialValue]);

  const onChange = () => {
    const values = form.getFieldValue('urls');
    _onChange(values.filter((url: string) => !!url).join(','));
  };

  return (
    <>
      <div className="content-plain-title">
        {required ? (
          <>
            <span className="content-plain-title-required">*</span>
            <span>{title}</span>
          </>
        ) : (
          title
        )}
      </div>
      <div className="content-input-box" style={{ height: 'auto' }}>
        <Form form={form} onValuesChange={onChange} autoComplete="off">
          <Form.List name="urls">
            {(fields, { add, remove }) => (
              <>
                {fields.map((field, index) => (
                  <>
                    <Row
                      wrap={false}
                      align="middle"
                      gutter={[6, 0]}
                      style={{ marginBottom: '6px' }}
                    >
                      <Col span={24}>
                        <Form.Item
                          {...field}
                          rules={[
                            {
                              validator(rule, value) {
                                if (!hrefValidate(value).status) {
                                  return Promise.reject(new Error(''));
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                          style={{ marginBottom: 0 }}
                        >
                          <Input
                            placeholder={placeholder}
                            disabled={disabled}
                          />
                        </Form.Item>
                      </Col>
                      {!disabled ? (
                        <Col>
                          <Space>
                            {fields.length > 1 ? (
                              <MinusCircleOutlined
                                onClick={() => remove(field.name)}
                                style={{ fontSize: '20px' }}
                              />
                            ) : null}
                            {fields.length - 1 === index ? (
                              <PlusCircleOutlined
                                style={{ fontSize: '20px' }}
                                onClick={() => add()}
                              />
                            ) : null}
                          </Space>
                        </Col>
                      ) : null}
                    </Row>
                  </>
                ))}
              </>
            )}
          </Form.List>
        </Form>
      </div>
    </>
  );
};

export default RedirectUrls;
